import { formatCurrency, formatDate } from '../fomatter.utils'
import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { LabelOptions } from '../types'

export class Label implements TicketElement {
  label: string | Date
  style: string
  valueType: 'string' | 'date' | 'currency'
  lineHeight: number
  align: CanvasTextAlign
  baseline: CanvasTextBaseline
  formattedLabel: string

  constructor(
    label: string | Date,
    { style, valueType, lineHeight, align, baseline }: LabelOptions = {}
  ) {
    this.label = label
    this.style = style || 'bold 16px'
    this.valueType = valueType || 'string'
    this.lineHeight = lineHeight || 22
    this.align = align || 'left'
    this.baseline = baseline || 'middle'
    if (this.valueType === 'date') {
      this.formattedLabel = formatDate(this.label)
    } else if (this.valueType === 'currency') {
      this.formattedLabel = formatCurrency(+this.label)
    } else {
      this.formattedLabel = String(this.label)
    }
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    ctx.font = `${this.style} ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textBaseline = this.baseline
    ctx.textAlign = this.align
    return this.lineHeight * splitLines(ctx, this.formattedLabel, width).length
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    const paddingTop = 20
    top += paddingTop
    ctx.font = `${this.style} ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textBaseline = this.baseline
    ctx.textAlign = this.align
    let left = 0
    if (this.align === 'center') {
      left = width / 2
    }
    wrapText(ctx, this.formattedLabel, left, top, width, {
      lineHeight: this.lineHeight,
      decreaseIndent: true
    })
  }
}
